<template>
  <div class="container sv sv043">

    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>いまさら聞けない！ローンの基礎知識</heading-one>

    <p class="_mb-md-60">ローン初心者の方に向けて、 ローンに関する気になる疑問や不安にお答えします。</p>

    <section id="section_01">

      <card-groups class="-image-top-list">
        <card-box router-name="sv009" class="-image-top">
          <card-header>
            <card-image class="-green"><img src="@/assets/images/sv/sv009/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </card-header>
          <card-body>「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</card-body>
        </card-box>
        <card-box router-name="sv010" class="-image-top">
          <card-header>
            <card-image class="-green"><img src="@/assets/images/sv/sv010/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">ローンの返済方法やルールとは？</h3>
          </card-header>
          <card-body>「お金を借りたらどうやって返すの…？」au PAY スマートローンの返済方法についてはこちら。</card-body>
        </card-box>
        <card-box router-name="sv011" class="-image-top">
          <card-header>
            <card-image class="-green"><img src="@/assets/images/sv/sv011/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">ローンって借りすぎないかな？</h3>
          </card-header>
          <card-body>借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」なんて方はこちら。</card-body>
        </card-box>
        <card-box router-name="sv012" class="-image-top">
          <card-header>
            <card-image class="-green"><img src="@/assets/images/sv/sv012/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">お金を借りたいけど、周りの人に知られない？</h3>
          </card-header>
          <card-body>「ローンのこと気になっていたけど、家族や恋人に知られないかな？」にお答えします。</card-body>
        </card-box>
      </card-groups>

      <btngroup-single class="-margin-lg">
        <btn-main class="-normal -lg" routerName="sv003">
          知っておきたい！ローンについてへ戻る
        </btn-main>
      </btngroup-single>

      <cv-box class="_mb-120 _mb-sm-60"/>

    </section>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import CardGroups from '../components/card/CardGroups'
import CardImage from '../components/card/CardImage'
import CvBox from '../components/box/CvBox'

export default {
  name: 'Sv-043',
  metaInfo: {
    title: 'いまさら聞けない！ローンの基礎知識｜知っておきたい！ローンについて',
    meta: [
      {name: 'description', content: '意外と知らないローンの基礎知識！ローン初心者の方に向けて、ローンに関する気になる疑問や不安について初心者でも分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローン知識,金利'}
    ]
  },
  components: {
    CvBox,
    BtnMain,
    BtngroupSingle,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: '知っておきたい！ローンについて',
        routerName: 'sv003'
      },
      {
        text: 'いまさら聞けない！ローンの基礎知識',
        active: true
      }
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Sv043.vue